import { getController } from '@/services/service'

const url = 'subscriptions'

export const subscriptionService = {
	...getController<Api.Subscription>(url),
}

export default subscriptionService
